// Used for fetching translations for labels throughout the app
import $api from '@/services/api';

let lastUpdated = 0;

// Arabic, Hebrew, Pashto, Urdu
// const rtlLanguages = ['ar', 'he', 'ps', 'ur'];

export default {
  namespaced: true,
  state: {
    languages: null,
    language: localStorage.language || 'en',
  },
  mutations: {
    setLanguages(state, val) {
      state.languages = val;
    },
    setLanguage(state, val) {
      state.language = val;
      localStorage.language = val;
    },
  },
  actions: {
    // Load the supported languages (that we support translations for) from the server
    async fetch({ commit, state }) {
      if (
        state.languages &&
        state.languages.length > 0 &&
        Date.now() - lastUpdated > 1000 * 60 * 15
      ) {
        return;
      }
      const languages = await $api.get('/v1/common/languages');
      // const tempLangs = [
      //   { code: 'en', english_name: 'English', local_name: 'English' },
      //   { code: 'fr', english_name: 'French', local_name: 'Français' },
      //   { code: 'pt', english_name: 'Portuguese', local_name: 'Portuguese' },
      // ];
      // commit('setLanguages', tempLangs);
      commit('setLanguages', languages);
      lastUpdated = Date.now();
    },
    setLanguage({ commit, dispatch }, language) {
      commit('setLanguage', language);
      dispatch('translations/fetch', null, { root: true });
      // render the app as "rtl" if the selected language is read from right to left
      // const dir = rtlLanguages.indexOf(language) > -1 ? 'rtl' : 'ltr';
      // document.querySelector('#app').setAttribute('dir', dir);
    },
  },
};
